import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider, RequireVoucher, RequireAdmin } from "./lib/auth";
import VoucherLogin from "./pages/VoucherLogin";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LandingPage from "./pages/LandingPage";
import QuizWizard from "./pages/QuizWizard";
import ResultsPage from "./pages/ResultsPage";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<VoucherLogin />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="/assessment" element={<RequireVoucher><LandingPage /></RequireVoucher>} />
            <Route path="/quiz" element={<RequireVoucher><QuizWizard /></RequireVoucher>} />
            <Route path="/results" element={<RequireVoucher><ResultsPage /></RequireVoucher>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
